/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {keyframes} from '@chakra-ui/react'
import {colors} from '../../../constants'

const navLinkAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
}`

export default {
    baseStyle: {
        container: {
            minWidth: 'xs',
            width: 'full',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            paddingLeft: 4,
            display: {base: 'none', xl: 'flex'}
        },
        stackContainer: {
            whiteSpace: 'nowrap',
            flexWrap: 'wrap'
        },
        popoverContent: {
            marginLeft: 'auto',
            marginRight: 'auto',
            border: 0,
            boxShadow: 'xl',
            paddingTop: '22px',
            paddingRight: 4,
            paddingBottom: '31px',
            paddingLeft: 4,
            minWidth: '100%',
            borderRadius: 0,
            position: 'absolute',
            top: '59px',
            borderTop: `0.4px solid ${colors.borderGray}`,
            transform: 'none !important',
            _focus: {
                boxShadow: 'none'
            }
        },
        popoverContainer: {
            paddingTop: 0,
            paddingRight: '10px',
            paddingLeft: '8px',
            animation: `${navLinkAnimation} 0.7s ease-in-out`,
            maxWidth: '100%'
        },
        listMenuTriggerContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        listMenuTriggerLink: {
            display: 'flex',
            whiteSpace: 'nowrap',
            position: 'relative',
            paddingTop: 3,
            paddingRight: 1,
            paddingBottom: 2,
            paddingLeft: 1,
            fontSize: '16px',
            fontWeight: 300,
            color: 'black',
            marginRight: '16px',
            px: 0,
            _hover: {
                textDecoration: 'none'
            }
        },
        listMenuTriggerLinkActive: {
            textDecoration: 'none',
            _before: {
                position: 'absolute',
                backgroundColor: 'transparent',
                content: `""`,
                height: '17px',
                borderBottom: `2px solid ${colors.blueCol}`,
                color: 'transparent',
                width: '100%',
                bottom: '-12px',
                left: '0px',
                zIndex: '11'
            }
        },
        listMenuTriggerLinkIcon: {
            marginTop: 3,
            marginBottom: 2,
            display: 'none',
            marginLeft: 0,
            _hover: {
                textDecoration: 'none'
            }
        },
        cardAlignment: {
            position: 'relative',
            cursor: 'pointer',
            width: '50%',
            borderRadius: '5px',
            backgroundColor: 'white',
            height: 'auto',
            padding: '0',
            color: 'black',
            maxHeight: '257px',
            maxWidth: '391px',
            _hover: {
                backgroundColor: 'white'
            }
        },
        textAlignment: {
            position: 'absolute',
            bottom: '22px',
            left: '22px',
            fontFamily: 'Raleway',
            fontWeight: '300'
        }
    },
    parts: [
        'container',
        'stackContainer',
        'popoverContent',
        'popoverContainer',
        'listMenuTriggerContainer',
        'listMenuTriggerLink',
        'listMenuTriggerLinkActive',
        'listMenuTriggerIcon'
    ]
}
